module.exports = __webpack_public_path__ + "img/enterprise-road-4.ac96b717.png";